import { render, staticRenderFns } from "./PrimkaPrintTable.vue?vue&type=template&id=071c1c8b&scoped=true&"
import script from "./PrimkaPrintTable.vue?vue&type=script&lang=js&"
export * from "./PrimkaPrintTable.vue?vue&type=script&lang=js&"
import style0 from "./PrimkaPrintTable.vue?vue&type=style&index=0&id=071c1c8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071c1c8b",
  null
  
)

export default component.exports